"use client";

import { createContext, type ReactNode, useContext } from "react";
import { usePathname } from "next/navigation";
import { shouldEnableImageGenerationSocket } from "@/lib/websocket/route-policy";
import { useImageGenerationSocket } from "./useImageGenerationSocket";

type ImageGenerationSocketContextValue = ReturnType<typeof useImageGenerationSocket>;

const ImageGenerationSocketContext = createContext<ImageGenerationSocketContextValue | null>(null);

export function ImageGenerationSocketProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const socket = useImageGenerationSocket({
    enabled: shouldEnableImageGenerationSocket(pathname),
  });

  return (
    <ImageGenerationSocketContext.Provider value={socket}>
      {children}
    </ImageGenerationSocketContext.Provider>
  );
}

export function useGlobalImageGenerationSocket() {
  const context = useContext(ImageGenerationSocketContext);
  if (!context) {
    throw new Error("useGlobalImageGenerationSocket must be used within ImageGenerationSocketProvider");
  }
  return context;
}
